var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"8"}},[(_vm.left)?_vm._t("left"):_vm._t("right")],2),_c('v-col',{staticClass:"d-flex flex-column",attrs:{"cols":"12","sm":"6","md":"4"}},[(_vm.left)?_vm._t("right"):_c('v-spacer'),(_vm.$slots.controls)?_vm._t("controls"):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }